var Strategy = require('./strategy');

// Export directly from package since there is nothing else to export
exports = module.exports = Strategy;

// Export constructor like before for compatibility
exports.Strategy = Strategy;
